import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

class EmpresaStatus extends Component {

  render() {
    const { status } = this.props.data;

    let text = '...';
    let variant = 'info';

    switch (status) {
      case 1:
        text = 'Activo';
        variant = 'success';
        break;

      case -1:
        text = 'Suspendido';
        variant = 'danger';
        break;
      default:
        break;
    }

    return <Badge variant={ variant }>{ text }</Badge>
  }
}

export default EmpresaStatus;